import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import LoadingState from './LoadingState.jsx';
import Sidebar from './Sidebar.jsx';

export default function ProtectedRoute() {
  const { status, operator, logout } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return (
      <div className="app-boot">
        <LoadingState label="Checking your session" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <div className="app-shell">
      <Sidebar operator={operator} onLogout={logout} />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
